"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERSION = void 0;
/**
 * SDK version.
 */
exports.VERSION = "2.0.5";
